import { useEffect, useState } from 'react';

/**
 * A media query as React state.
 *
 * Needed because the sidebar behaves as two different things: a drawer that
 * slides on a phone, and a rail that changes width on a desktop. Deciding which
 * from CSS alone is not enough — the markup itself differs, since a collapsed
 * rail renders icons without labels and a drawer never should.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false,
  );

  useEffect(() => {
    const mq = window.matchMedia(query);
    const onChange = (event: MediaQueryListEvent) => setMatches(event.matches);

    setMatches(mq.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

/** The breakpoint the sidebar switches behaviour at, matching Tailwind's `lg`. */
export const useIsDesktop = () => useMediaQuery('(min-width: 1024px)');
